import {Link} from 'react-router-dom';
import {useAppContext} from "../../utils/AppContext";
import {nav_en} from '../../assets/texts/en.js';

const Footer = () => {
    const {
        screenSize,
        isMediumScreen,
        activePage, setActivePage,
    } = useAppContext();

    const footerContainer = (!screenSize)? "footer-container" : `footer-container footer-container${screenSize}`;
    const footerItemsContainer = (!screenSize)? "footer-items-container" : `footer-items-container footer-items-container${screenSize}`;
    const textButtonContainer = (!screenSize)? "text-button-container" : `text-button-container text-button-container${screenSize}`;
    const textButtonText = (!screenSize)? "text-button-text" : `text-button-text text-button-text${screenSize}`;

    const footerItemLink = ({item}) => (
        item.id === "contact"?
        <li key={item.id}>
            <button 
                className={`${textButtonContainer}${activePage === item.id ? " active" : ""}`}
                onClick={() => window.location.href = "mailto:hello@maze.do"}
            >
            <span className={textButtonText}>{item.title}</span>
            </button>
        </li>
        :
        <li key={item.id}>
            <Link 
                className={`${textButtonContainer}${activePage === item.id ? " active" : ""}`}
                to={item.path} 
                onClick={() => setActivePage(item.id)}
            >
            <span className={textButtonText}>{item.title}</span>
            </Link>
        </li>
    );

    return (
        <div className={footerContainer}>
            {!isMediumScreen && <div className="divider-line"/>}
            <ul className={footerItemsContainer}>
                {nav_en.footer.map((item, index) => (
                    footerItemLink({item, index})
                ))}
            </ul>
        </div>
    );

};

export default Footer;
